import { SessionActionTypes } from './session.actions';
import { Action } from '@ngrx/store';
import { Session, Usuario, OtherSystemData, UsuarioExpiracionClave } from 'src/app/session/store/session';
import { CambioClaveMotivoErrorEnum } from './session.selectors';


export interface SessionState {
	open: boolean,			// indica si hay una sesión abierta
	onCreate: boolean,		// indica si se está en proceso de create session
	onInit: boolean,		// indica si el session store está en proceso de creación de una sesión
	useTokenAcceso: boolean,// indica si se debe usar el token de acceso que se encuentra en una cookie
	tokenSesion: string,	// token actual correspondiente a la sesión
	usuario: Usuario,		// datos del usuario
	otherSystemData: OtherSystemData,	// datos del usuario adicionales
	valid: boolean,			// indica si la sesión es válida
	connectionType: string,	// puede tener los valores lan o dmz
	sedeType: string, 		// puede tener los valores central o sanjusto
	validDate: boolean		// indica si la fecha del cliente es válida respecto de la del servidor,
	postponePassExpirationReady: boolean,	// indica si la actualización de la fecha de expiración de la clave está lista
	cambioClaveReady: boolean,	// indica si se está llevando adelante un cambio de clave en el backend
	cambioClaveMotivoError: CambioClaveMotivoErrorEnum		// indica el motivo del error del último intento de cambio de clave
}

export const initialSessionState: SessionState = {
	open: false,
	onCreate: null,
	onInit: false,
	useTokenAcceso: null,
	tokenSesion: null,
	usuario: null,
	otherSystemData: null,
	valid: null,
	connectionType: null,
	sedeType: null,
	validDate: null,
	postponePassExpirationReady: true,
	cambioClaveReady: true,
	cambioClaveMotivoError: null
};

export function sessionReducer( state = initialSessionState, action: Action ): SessionState {
	let session: Session;
	let token: string;
	let otherSystemData: OtherSystemData;

	switch( action.type ) {
		case SessionActionTypes.AfterLoginRequested:
			otherSystemData = { idPersonaInstitucional: action["payload"]["idPersonaInstitucional"] };
			return { ...state, onInit: true, otherSystemData, useTokenAcceso: action["payload"]["useTokenAcceso"] };

// SessionCreate related actions
		case SessionActionTypes.SessionCreateRequested:
			return { ...state, onCreate: true };
		case SessionActionTypes.SessionCreateLoaded:
			let session: Session = action["payload"]["session"];
			let tokenSesion: string = session.token;
			let usuario: Usuario = session.usuario;
			otherSystemData = session.otherSystemData;
			return { ...state, onCreate: false, tokenSesion, usuario, otherSystemData };
		case SessionActionTypes.SessionCreateCancelled:
			return { ...state, onCreate: false, onInit: false };

// SessionOpen related actions
		case SessionActionTypes.SessionOpenLoaded:
			return { ...state, onInit: false, open: true };

		case SessionActionTypes.SessionExpirationRequested:
		case SessionActionTypes.SessionOpenCancelled:
			return initialSessionState;

		case SessionActionTypes.RefreshSessionRequested:
			otherSystemData = {
				idPersonaInstitucional: action["payload"]["idPersonaInstitucional"],
				phpSession: action["payload"]["phpSession"],
				ce: action["payload"]["ce"],
				session: action["payload"]["session"]
			};
			return { ...state, onInit: true, otherSystemData };
		case SessionActionTypes.RefreshTokenRequested:
			return { ...state, tokenSesion: action["payload"]["tokenSesion"] };		// Tiene sentido asignar tokenSesion sólo en el caso de venir del auth.interceptor
		case SessionActionTypes.SessionDisableRequested:
			return { ...state, tokenSesion: null, otherSystemData: null };

// SessionValidate related actions
		case SessionActionTypes.ValidateSessionRequested:
			return { ...state, valid: null };
		case SessionActionTypes.ValidateSessionDone:
			return { ...state, valid: action["payload"]["valid"] };

// Misc related actions
		case SessionActionTypes.XTargetUpdated:
			let connectionType: string = action["payload"]["connectionType"];
			return { ...state, connectionType };
		case SessionActionTypes.XViaUpdated:
			let sedeType: string = action["payload"]["sedeType"];
			return { ...state, sedeType };

		case SessionActionTypes.VerifyDateDone:
			let validDate: boolean = action["payload"]["validDate"];
			return { ...state, validDate };

// Expiración Clave y Cambio de Clave
		case SessionActionTypes.PostponePassExpirationRequested:
			return { ...state, postponePassExpirationReady: false };
		case SessionActionTypes.PostponePassExpirationLoaded:
			let darAviso: boolean = action["payload"]["darAviso"]["darAviso"];
			return { ...state, usuario: { ...state.usuario, expiracionClave: { ...state.usuario.expiracionClave, darAviso } }, postponePassExpirationReady: true };
		case SessionActionTypes.PostponePassExpirationCancelled:
			return { ...state, postponePassExpirationReady: true };
		case SessionActionTypes.CambioClaveRequested:
			return { ...state, cambioClaveMotivoError: null, cambioClaveReady: false };
		case SessionActionTypes.CambioClaveDone:
			let expiracionClave: UsuarioExpiracionClave = action["payload"]["usuarioExpiracionClave"];
			return { ...state, open: false, usuario: { ...state.usuario, expiracionClave }, cambioClaveMotivoError: null, cambioClaveReady: true };
		case SessionActionTypes.CambioClaveCancelled:
			let cambioClaveMotivoError: CambioClaveMotivoErrorEnum = action["payload"]["motivo"];
			return { ...state, open: true, cambioClaveMotivoError, cambioClaveReady: true };

		default:
			return state;
	}
}
